import axios from '../../axios'

/*
 * 实体小程序数据接口
 */
// 获取实体小程序列表
export const getBindList = (data) => {
    return axios({
        url: '/api/course/tiktok/bind/page',
        method: 'get',
        data
    })
}

// 实体小程序id查询
export const getBindId = (data) => {
    return axios({
        url: '/api/course/tiktok/bind/get',
        method: 'get',
        data
    })
}

// 新增实体小程序信息
export const addBind = (data) => {
    return axios({
        url: '/api/course/tiktok/bind',
        method: 'post',
        data
    })
}

// 编辑实体小程序信息
export const updateBind = (data) => {
    return axios({
        url: '/api/course/tiktok/bind',
        method: 'put',
        data
    })
}

// 绑定实体小程序
export const bindEntirySource = (data) => {
    return axios({
        url: '/api/course/tiktok/bind/submit',
        method: 'post',
        data
    })
}

// 解绑实体小程序
export const unbindEntirySource = (data) => {
    return axios({
        url: '/api/course/tiktok/bind/unbind',
        method: 'post',
        data
    })
}

// 实体小程序绑定查询
export const searchBindEntiry = (data) => {
    return axios({
        url: '/api/course/tiktok/bind/query',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/tiktok/bind.js